import React, { createContext, useContext, useState } from 'react';
import CustomAlert from '../components/CustomAlert';

const AlertContext = createContext();

export const useAlert = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }
  return context;
};

export const AlertProvider = ({ children }) => {
  const [alert, setAlert] = useState(null);

  const showAlert = (options) => {
    if (typeof options === 'string') {
      // 간단한 문자열인 경우 info 타입으로 처리
      setAlert({
        type: 'info',
        message: options
      });
    } else {
      setAlert(options);
    }
  };

  const showSuccess = (message, title = null) => {
    setAlert({
      type: 'success',
      title: title || '성공',
      message
    });
  };

  const showError = (message, title = null) => {
    setAlert({
      type: 'error',
      title: title || '오류',
      message
    });
  };

  const showWarning = (message, title = null) => {
    setAlert({
      type: 'warning',
      title: title || '경고',
      message
    });
  };

  const showInfo = (message, title = null) => {
    setAlert({
      type: 'info',
      title: title || '알림',
      message
    });
  };

  const showModal = (message, title = null, type = 'info') => {
    setAlert({
      type: type,
      title: title || '알림',
      message,
      persistent: true  // 자동으로 닫히지 않음
    });
  };

  const showConfirm = (message, onConfirm, onCancel = null, title = '확인') => {
    setAlert({
      type: 'warning',
      title,
      message,
      persistent: true,  // 자동으로 닫히지 않음
      actions: [
        {
          label: '취소',
          style: 'btn-secondary',
          onClick: onCancel || (() => {})
        },
        {
          label: '확인',
          style: 'btn-primary',
          onClick: onConfirm
        }
      ]
    });
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const value = {
    showAlert,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    showModal,
    showConfirm,
    hideAlert
  };

  return (
    <AlertContext.Provider value={value}>
      {children}
      <CustomAlert alert={alert} onClose={hideAlert} />
    </AlertContext.Provider>
  );
};

export default AlertContext; 